function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ASSIGNEE_PICKER_COMPANY, ASSIGNEE_PICKER_ROLE, ASSIGNEE_PICKER_USER } from '../consts';
export const transformRoles = function (roles, valueGetter, T, statusFilters, roleOptionsFilter, additionalDataFields) {
  let rolesMemberCount = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  let postTransform = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : result => result;
  return postTransform(roles.reduce((result, role, i) => {
    const isStatusVisible = !statusFilters || statusFilters.includes(role.status);
    const isOptionVisible = !roleOptionsFilter || roleOptionsFilter(role, i, roles, rolesMemberCount);
    if (isStatusVisible && isOptionVisible) {
      result.push(_objectSpread(_objectSpread({}, additionalDataFields === null || additionalDataFields === void 0 ? void 0 : additionalDataFields.reduce((a, v) => _objectSpread(_objectSpread({}, a), {}, {
        [v]: role[v]
      }), {})), {}, {
        label: role.name,
        value: role[valueGetter],
        subtext: T.translate('MEMBERS_COUNT', {
          context: rolesMemberCount[role.id] || 0
        }),
        group: ASSIGNEE_PICKER_ROLE
      }));
    }
    return result;
  }, []));
};
export const transformUsers = function (users, valueGetter, formatDisplayUser, statusFilters, userOptionsFilter, additionalDataFields) {
  let idToNameMap = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  let userOptionSubtextRenderer = arguments.length > 7 ? arguments[7] : undefined;
  let postTransform = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : result => result;
  const rolesCountMap = {};
  const options = postTransform(users.reduce((result, user, i) => {
    var _user$roleIds;
    const isStatusVisible = !statusFilters || statusFilters.includes(user.status);
    const isOptionVisible = !userOptionsFilter || userOptionsFilter(user, i, users);
    (_user$roleIds = user.roleIds) === null || _user$roleIds === void 0 ? void 0 : _user$roleIds.forEach(roleId => {
      rolesCountMap[roleId] = (rolesCountMap[roleId] || 0) + 1;
    });
    if (isStatusVisible && isOptionVisible && user.autodeskId) {
      result.push(_objectSpread(_objectSpread({}, additionalDataFields === null || additionalDataFields === void 0 ? void 0 : additionalDataFields.reduce((a, v) => _objectSpread(_objectSpread({}, a), {}, {
        [v]: user[v]
      }), {})), {}, {
        label: formatDisplayUser(user.autodeskId).displayName || user.name || user.email,
        value: user[valueGetter],
        subtext: userOptionSubtextRenderer ? userOptionSubtextRenderer(user) : (idToNameMap === null || idToNameMap === void 0 ? void 0 : idToNameMap[user === null || user === void 0 ? void 0 : user.companyId]) || '',
        group: ASSIGNEE_PICKER_USER,
        imageUrl: user === null || user === void 0 ? void 0 : user.imageUrl
      }));
    }
    return result;
  }, []));
  return [rolesCountMap, options];
};
export const transformCompanies = function (companies, valueGetter, T, statusFilters, companyOptionsFilter, additionalDataFields) {
  let postTransform = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : result => result;
  const idToNameMap = {};
  const options = postTransform(companies.reduce((result, company, i) => {
    const isStatusVisible = !statusFilters || company.status && statusFilters.includes(company.status);
    const isOptionVisible = !companyOptionsFilter || companyOptionsFilter(company, i, companies);
    if (isStatusVisible) {
      idToNameMap[company.id] = company.name;
      if (isOptionVisible) {
        result.push(_objectSpread(_objectSpread({}, additionalDataFields === null || additionalDataFields === void 0 ? void 0 : additionalDataFields.reduce((a, v) => _objectSpread(_objectSpread({}, a), {}, {
          [v]: company[v]
        }), {})), {}, {
          label: company.name,
          value: company[valueGetter],
          group: ASSIGNEE_PICKER_COMPANY,
          subtext: T.translate('MEMBERS_COUNT', {
            context: company.memberCount
          }),
          imageUrl: company === null || company === void 0 ? void 0 : company.imageUrl
        }));
      }
    }
    return result;
  }, []));
  return [idToNameMap, options];
};
//# sourceMappingURL=formatters.js.map